import React, { useEffect } from "react";
import Background_Member2 from "../../assets/images/inner-banner.jpg";
import { Link } from "react-router-dom";
import REFUNDFORM from "../../assets/pdf/refund/APPLICATION FORM FOR REFUND.pdf";

const PrivacyPolicy = () => {
  document.title =
    "Privacy Policy | Gujarat State Allied and Healthcare Council";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="wrappermain">
        <div
          className="banner-image wrappermain"
          style={{
            backgroundImage: "url(" + Background_Member2 + ")",
            backgroundSize: "fill",
            backgroundPosition: "right",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            padding: "25px 0",
          }}
        >
          <div className="banner-inner-breadcrumb">
            <div className="container">
              <nav aria-label="breadcrumb">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Privacy Policy
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <div className="privacy-policy-wrapper p-t-60 p-b-60">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div className="terms-conditions-desc py-2">
                  <h3>Privacy Policy</h3>
                  <p>
                    The terms &quot;We&quot; / &quot;Us&quot; /
                    &quot;Our&quot;/”Company” individually and collectively
                    refer to <strong>Gujarat State Allied and Healthcare Council</strong> and the
                    terms &quot;You&quot; /&quot;Your&quot; /
                    &quot;Yourself&quot; refer to the users.
                  </p>
                  <p>
                    This Privacy Policy is an electronic record in the form of
                    an electronic contract formed under the information
                    Technology Act, 2000 and the rules made thereunder and the
                    amended provisions pertaining to electronic documents /
                    records in various statutes as amended by the information
                    Technology Act, 2000. This Privacy Policy does not require
                    any physical, electronic or digital signature.
                  </p>
                  <p>
                    This Privacy Policy is a legally binding document between
                    you and <strong>Gujarat State Allied and Healthcare Council</strong> (both
                    terms defined below). The terms of this Privacy Policy will
                    be effective upon your acceptance of the same (directly or
                    indirectly in electronic form, by clicking on the “I accept”
                    tab or by use of the website or by other means) and will
                    govern the relationship between you and <strong>Gujarat State Allied
                    and Healthcare Council.</strong> for your use of the website
                    “Website” (defined below).
                  </p>
                  <p>
                    This document is published and shall be construed in
                    accordance with the provisions of the Information Technology
                    (reasonable security practices and procedures and sensitive
                    personal data of information) rules, 2011 under Information
                    Technology Act, 2000; that require publishing of the Privacy
                    Policy for collection, use, storage and transfer of
                    sensitive personal data or information.
                  </p>
                  <p>
                    Please read this Privacy Policy carefully by using the
                    Website, you indicate that you understand, agree and consent
                    to this Privacy Policy. If you do not agree with the terms
                    of this Privacy Policy, please do not use this Website.
                  </p>
                  <p>
                    By providing us your Information or by making use of the
                    facilities provided by the Website, You hereby consent to
                    the collection, storage, processing and transfer of any or
                    all of Your Personal Information and Non-Personal
                    Information by us as specified under this Privacy Policy.
                    You further agree that such collection, use, storage and
                    transfer of Your Information shall not cause any loss or
                    wrongful gain to you or any other person.
                  </p>
                    <br />
                  <h3>Refund and Cancellation Policy</h3>
                  <p>If any Candidate has made excess payment either by mistake or by inadvertence resulting in more payment than
                  actual fees, the same should be refunded to candidate by cheque.</p>
                  <p><Link to={REFUNDFORM} target="_blank">Click here </Link>to apply for refund (Kindly send the hard copy of refund form and receipt of payment at the council office.
Refund amount will be sent by Cheque at registered address within 30 days of receiving refund form.)
Withdrawal of application - where a person who after submitting for application for registration applies for withdrawal
or his registration is refused, he shall be refunded the application fees after deducting one hundred rupees towards
administrative expenses.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
